export class KeyAccountFilter {
    public IncludeInactive?: boolean;
}

export default KeyAccountFilter;